import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { Spin } from 'antd';
import { store } from './redux/store';
import microApp from '@micro-zoe/micro-app';
import App from './App';
import { startPageLifecycleProbe } from './utils/pageLifecycleProbe';
import './base.scss';
import '@jd/x-coreui/lib/index.css';
const rootNode = document.getElementById('root')!;
const root = ReactDOM.createRoot(rootNode);
const height = window.innerHeight / 2;
startPageLifecycleProbe();
root.render(
  <React.Suspense
    fallback={
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: `${height}px`,
        }}
      >
        <Spin />
      </div>
    }
  >
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.Suspense>,
);
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
microApp.start();
